import {
  IResourceComponentsProps,
  useNavigation,
  useShow,
  useTable,
  useCan,
  useGetIdentity,
  useMany,
  useList,
  useUpdate,
  CrudFilter,
  CrudSort,
} from '@pankod/refine-core'
import { useEffect, useState } from 'react'
import { Badge } from 'antd'
import {
  List,
  RefreshButton,
  CreateButton,
  ExportButton,
  Table,
  Space,
  EditButton,
  DeleteButton,
  CloneButton,
  ShowButton,
  DateField,
  getDefaultSortOrder,
  useModalForm,
  Icons,
  TagField,
  Progress,
  Menu,
  Typography,
  Button,
  message,
  Popconfirm,
  Select,
  Avatar,
  Tooltip,
  Radio,
  Input,
  Divider,
  Form,
  Col,
  Row,
} from '@pankod/refine-antd'
import 'styles/custom.css'
import { TableColumnsType, Tag } from 'antd'
import { IPaper, IWorkRequest } from 'interfaces'
import { CloneWorkRequest } from 'pages/workrequests/clone'
import { CreateWorkRequest } from 'pages/workrequests'
import { EditWorkRequest } from 'pages/workrequests'
import { QuestionFilter } from 'components/filters/questionFilter'
import { MoreFilter } from 'components/filters/moreFilters'
import Permissions from 'permissions'

import metaData from 'metadata/workrequests'
import { useUserContext } from 'context/user'
import { PaginationProps } from 'antd'
import { getWorkRequestByConditions, getAllWorkRequest, getCount } from 'gql/query'
const { PlusOutlined, AppstoreOutlined, CopyOutlined, DeleteOutlined } = Icons
const { Text, Link } = Typography
const { Search } = Input
type Permission = {
  granted?: boolean
}
type IWorkRequestList = {
  request?: IPaper
}
interface QuestionSearch {
  question_search: string
}
interface Count {
  closedWorkRequest: number
  inProgressWorkRequest: number
  openWorkRequest: number
  draftWorkRequest: number
  totalCount: number
}
export const WorkRequestsTable: React.FC<IWorkRequestList> = ({ request }) => {
  const { data: user } = useGetIdentity()
  const { userRole, userLastSearch, updateUserLastSearch } = useUserContext()
  const { show, push } = useNavigation()
  const [enableQuery, setEnableQuery] = useState(false)
  const [formSearch] = Form.useForm<QuestionSearch>()
  const [searchText, setSearchText] = useState('')
  const [readPermission, setReadPermission] = useState<Permission>({})
  const [createPermission, setCreatePermission] = useState<Permission>({})
  const [editPermission, setEditPermission] = useState<Permission>({})
  const [deletePermission, setDeletePermission] = useState<Permission>({})
  const [refresh, setRefresh] = useState(false)
  const [wrFilter, setWRFilter] = useState<CrudFilter[]>([])
  const [wrAllFilter, setWRAllFilter] = useState<string>('')
  const [sortBy, setSortBy] = useState('created_at')
  const [sortOrder, setSortOrder] = useState('asc')
  const [success, setSuccess] = useState(false)
  const [workRequestCount, setWorkRequestCount] = useState<Count>({
    closedWorkRequest: 0,
    inProgressWorkRequest: 0,
    openWorkRequest: 0,
    draftWorkRequest: 0,
    totalCount: 0,
  })
  const { filters, setFilters, setSorter, tableQueryResult, current, setCurrent, setPageSize } = useTable<IWorkRequest>({
    queryOptions: {
      enabled: enableQuery,
    },
    resource: 'work_requests',

    initialSorter: [
      {
        field: 'created_at',
        order: 'desc',
      },
    ],
    permanentFilter: [
      {
        field: 'active',
        operator: 'eq',
        value: 'true',
      },
    ],
    metaData,
  })

  const findCount = async () => {
    try {
      let userId = user?.id
      let isAdmin = userRole === 'admin'
      let userrole = userRole
      const resource = 'work_requests'
      const respnonseFindCount: any = await getCount({ userId, isAdmin, userrole, resource })
      const closedWorkRequest = respnonseFindCount?.closedWorkRequestCount?.aggregate?.count
      const inProgressWorkRequest = respnonseFindCount?.inProgressWorkRequestCount?.aggregate?.count
      const openWorkRequest = respnonseFindCount?.openWorkRequestCount?.aggregate?.count
      const draftWorkRequest = respnonseFindCount?.draftWorkRequestCount?.aggregate?.count
      let totalCount = closedWorkRequest + inProgressWorkRequest + openWorkRequest + draftWorkRequest
      setWorkRequestCount({ closedWorkRequest, inProgressWorkRequest, openWorkRequest, draftWorkRequest, totalCount })
    } catch (err) {
      console.log(err, 'error')
    }
  }
  useEffect(() => {
    if (!readPermission?.granted && readPermission?.granted !== undefined) {
      push('/')
    } else {
      findCount()
    }
  }, [readPermission])
  const { mutate } = useUpdate<IWorkRequest>()
  useEffect(() => {
    if (userRole !== undefined) {
      setReadPermission(Permissions.can(userRole).readAny('work_requests'))
      setCreatePermission(Permissions.can(userRole).createAny('work_requests'))
      setEditPermission(Permissions.can(userRole).updateAny('work_requests'))
      setDeletePermission(Permissions.can(userRole).deleteAny('work_requests'))
    }
    {
      request ? setCurrent(1) : setCurrent(parseInt(localStorage.getItem(`workrequestpage-${userRole}`) ?? '1'))
    }
    if (userLastSearch?.work_requests) {
      formSearch.setFieldsValue({ question_search: userLastSearch.work_requests })
      setSearchText(userLastSearch.work_requests)
      setFilters([
        {
          field: 'name',
          operator: 'contains',
          value: `%${userLastSearch.work_requests}%`,
        },
      ])
    }
  }, [userRole])

  const [currentFilter, setCurrentFilter] = useState('')
  const { queryResult, setShowId } = useShow<IWorkRequest>({
    resource: 'work_requests',
    metaData,
  })
  const { data: showQueryResult } = queryResult
  const record = showQueryResult?.data
  const refreshData = () => {
    setSortBy('created_at')
    setSortOrder('asc')
    setRefresh(!refresh)
    // getAllWorkRequest(wrFilter, limit, offset, sortBy, sortOrder).then((resp: any) => {
    //   setTableData(resp?.work_requests)
    //   setTableTotal(resp?.work_requests_aggregate?.aggregate?.count)
    // })
  }
  useEffect(() => {
    let arrFilter: CrudFilter[] = []
    filters.splice(0, filters.length)
    setFilters([])
    setFilters([
      {
        field: 'active',
        operator: 'eq',
        value: true,
      },
    ])
    if (userRole === 'subjectincharge') {
      arrFilter.push({
        operator: 'or',
        value: [
          { field: 'subject_incharge_id', operator: 'eq', value: user?.id },
          { field: 'created_by', operator: 'eq', value: user?.id },
        ],
      })
    } else if (userRole === 'qcreator') {
      filters.filter((item: any) => item?.field == 'created_by')
      arrFilter = []

      arrFilter.push({
        field: 'status',
        operator: 'ne',
        value: 'Draft',
      })
      arrFilter.push({
        field: 'creator_id',
        operator: 'eq',
        value: user?.id,
      })
      arrFilter.push({
        field: 'request_type',
        operator: 'ne',
        value: 'V',
      })
    } else if (userRole === 'variantcreator') {
      filters.filter((item: any) => item?.field == 'created_by')
      arrFilter = []

      arrFilter.push({
        field: 'status',
        operator: 'ne',
        value: 'Draft',
      })
      arrFilter.push({
        field: 'creator_id',
        operator: 'eq',
        value: user?.id,
      })
      arrFilter.push({
        field: 'request_type',
        operator: 'eq',
        value: 'V',
      })
    } else if (userRole === 'qapprover') {
      arrFilter = []
      arrFilter.push({
        field: 'status',
        operator: 'ne',
        value: 'Draft',
      })
      arrFilter.push({
        field: 'workRequestApprovers.approver_id',
        operator: 'eq',
        value: user?.id,
      })
    } else if (userRole === 'qreviewer') {
      arrFilter = []
      arrFilter.push({
        field: 'status',
        operator: 'ne',
        value: 'Draft',
      })
      arrFilter.push({
        field: 'workRequestReviewers.user_id',
        operator: 'eq',
        value: user?.id,
      })
    }
    setWRFilter(arrFilter)
    setFilters(arrFilter)
    setEnableQuery(true)
    // setLoading(false)
  }, [userRole])

  useEffect(() => {
    if (request !== undefined) {
      setFilters([{ field: 'paper_id', operator: 'eq', value: request?.id }])
    }
  }, [request])

  const {
    formProps: createFormProps,
    modalProps: createModalProps,
    close: createClose,
    show: createShow,
  } = useModalForm({
    resource: 'work_requests',
    action: 'create',
    warnWhenUnsavedChanges: true,
    onMutationSuccess(data, variables, context) {
      if (data?.data?.id) {
        setSuccess(true)
      }
    },
  })
  const {
    formProps: editFormProps,
    modalProps: editModalProps,
    show: editShow,
    close: editClose,
  } = useModalForm({
    resource: 'work_requests',
    action: 'edit',
    // warnWhenUnsavedChanges: true,
    metaData,
  })
  const {
    formProps: cloneFormProps,
    modalProps: cloneModalProps,
    show: cloneShow,
    close: cloneClose,
  } = useModalForm({
    resource: 'work_requests',
    action: 'clone',
    warnWhenUnsavedChanges: true,
    metaData,
  })

  const renderApproveCount = (work_request: any) => {
    let approved_count = 0
    work_request?.questions?.length > 0 &&
      work_request?.questions?.map((element: any) => {
        if (element?.status === 'Published') approved_count++
      })
    return approved_count.toFixed(0)
  }
  const renderReviewCount = (work_request: any) => {
    let review_count = 0
    work_request?.questions?.length > 0 &&
      work_request?.questions?.map((element: any) => {
        if (element?.status === 'For Approval' || element?.status === 'Published') review_count++
      })
    // work_request?.push({ review_count: review_count })
    return review_count.toFixed(0)
  }
  const renderRejectedAtReview = (record: any) => {
    let rejected_review_count = 0
    record?.questions?.length > 0 &&
      record?.questions?.map((element: any) => {
        if (element?.status === 'Rejected at Review' || element?.status === 'For Review (Require Amending)') rejected_review_count++
      })
    // work_request?.push({ review_count: review_count })
    return rejected_review_count.toFixed(0)
  }
  const confirm = async (e: React.MouseEvent<HTMLElement>, id: string) => {
    await mutate(
      {
        resource: 'work_requests',
        id: id,
        values: { active: false },
      },
      {
        onSuccess: () => {
          findCount()
        },
      }
    )
  }

  const cancel = (e: React.MouseEvent<HTMLElement>) => {
    message.error('Click on No')
  }

  const columns: TableColumnsType<IWorkRequest> = [
    {
      dataIndex: 'request_id',
      title: 'Id',
    },
    {
      title: 'Name',
      dataIndex: 'name',
      sorter: (a, b) => a.name.localeCompare(b.name),
      render: (_, record) => (
        <>
          <ShowButton
            size="small"
            type="link"
            icon={null}
            recordItemId={record.id}
            onClick={() => {
              show('work_requests', record.id)
            }}
          >
            <Text
              className="ams-table-link-text"
              style={{
                width: 150,
                textAlign: 'left',
                cursor: 'pointer',
              }}
              ellipsis={{ tooltip: record?.name }}
            >
              {record?.name}
            </Text>
          </ShowButton>
        </>
      ),
    },
    {
      dataIndex: 'request_type',
      title: 'Type',
      render(value, record, index) {
        return (
          <Space>
            <Text>{value}</Text>
            {record?.paper_wr_type ? <Tag color={record?.paper_wr_type === 'Normal' ? 'blue' : 'purple'}>{record?.paper_wr_type}</Tag> : null}
          </Space>
        )
      },
    },

    {
      dataIndex: 'grade_ids',
      title: 'Grades',
      render: (_, { workRequestGrades }) => (
        <>
          {workRequestGrades?.length > 0 ? (
            <div>
              {workRequestGrades?.length > 1 ? (
                <Badge size="small" count={workRequestGrades?.length - 1} style={{ background: '#6659ff' }}>
                  {/* <Tooltip title="prompt text" color={'#6659ff'} key={'#6659ff'}> */}
                  <Tag color={'blue'} key={workRequestGrades?.[0]?.grade?.name}>
                    {workRequestGrades?.[0]?.grade?.name}
                  </Tag>
                  {/* </Tooltip> */}
                </Badge>
              ) : (
                <Tag color={'blue'} key={workRequestGrades?.[0]?.grade?.name}>
                  {workRequestGrades[0]?.grade?.name}
                </Tag>
              )}
            </div>
          ) : null}
        </>
      ),
      // render: (_, record) => renderGrades(record?.grade_ids),
    },
    {
      dataIndex: 'subject_id',
      title: 'Subject',
      render: (_, record) => (
        <Text style={{ width: 70, textAlign: 'left' }} ellipsis={{ tooltip: record?.subject?.name }}>
          {record?.subject?.name}
        </Text>
      ),
    },
    {
      dataIndex: 'status',
      title: 'Stage',
      // width: 100,
      className: 'ant-table-column-sort',
      render: value => (
        <Tag
          color={
            value === 'Completed'
              ? 'green'
              : value === 'Draft'
              ? 'pink'
              : value === 'Closed'
              ? 'volcano'
              : value === 'Bulk Request' || value === 'Urgent Request'
              ? 'pink'
              : 'geekblue'
          }
        >
          {value}
        </Tag>
      ),
    },
    {
      dataIndex: 'created_at',
      title: 'Created At',
      sorter: (a, b) => new Date(a.created_at).getTime() - new Date(b.created_at).getTime(),
      render: value => <DateField format="DD-MMM-YY" value={value} />,
    },
    {
      dataIndex: 'due_date',
      title: 'Due Date',
      sorter: (a, b) => new Date(a.due_date).getTime() - new Date(b.due_date).getTime(),
      render: value => (value !== null ? <DateField format="DD-MMM-YY" value={value} /> : ''),
    },
    {
      dataIndex: 'over_all_status',
      title: 'Status',
      // width: 100,
      className: 'ant-table-column-sort',
      render: (_, record) => <Progress percent={!isNaN(record?.completion_status) ? record?.completion_status.toFixed(0) : NaN} type="line" />,
    },

    {
      dataIndex: 'count',
      title: 'T',
    },
    {
      dataIndex: 'create_count',
      title: 'C',
      render: (_, record) => record?.questions?.length - parseInt(renderRejectedAtReview(record)),
    },
    {
      dataIndex: 'review_count',
      title: 'R',
      render: (_, record) => <>{parseInt(renderReviewCount(record))}</>,
    },
    {
      dataIndex: 'approve_count',
      title: 'A',
      render: (_, record) => <>{renderApproveCount(record)}</>,
    },

    {
      className: editPermission !== undefined && editPermission?.granted ? 'show' : 'hide',
      title: 'Actions',
      dataIndex: 'actions',
      render: (_, record) => (
        <Space>
          {editPermission !== undefined && editPermission?.granted
            ? record?.status !== 'Closed' && (
                <EditButton
                  disabled={
                    (record?.status === 'Draft' && !!record?.subject_incharge_id && record?.created_by !== record?.subject_incharge_id) ||
                    (!!record?.subject_incharge_id && record?.subject_incharge_id !== user?.id)
                  }
                  key="wr_edit"
                  size="small"
                  type="link"
                  hideText
                  title="Edit"
                  recordItemId={record.id}
                  onClick={() => {
                    setShowId(record.id)
                    editShow(record.id)
                  }}
                />
              )
            : null}
          {editPermission !== undefined && editPermission?.granted ? (
            <CloneButton
              key="wr_clone"
              size="small"
              type="link"
              hideText
              hidden={!!record?.subject_incharge_id}
              title="Clone"
              icon={<CopyOutlined />}
              recordItemId={record.id}
              onClick={() => {
                setShowId(record.id)
                cloneShow(record.id)
              }}
            />
          ) : null}
          {deletePermission !== undefined && deletePermission?.granted ? (
            <Popconfirm
              title="Are you sure to delete this task?"
              onConfirm={(e: any) => confirm(e, record.id)}
              onCancel={(e: any) => cancel(e)}
              okText="Yes"
              cancelText="No"
            >
              {record?.status === 'Open' || record?.status === 'Draft' ? <DeleteOutlined style={{ color: 'red' }} /> : null}
            </Popconfirm>
          ) : // <DeleteButton key="wr_delete" size="small" type="link" title="Delete" hideText recordItemId={record.id} />
          null}
        </Space>
      ),
    },
  ]
  const filterByCompletionStatus = (min: any, max: any) => {
    // let arr: string[] = []
    // tableQueryResult?.data?.data?.map((item: any) => {
    //   let over_all = renderOverallCount(item)
    //   if (parseInt(over_all) > parseInt(min) && parseInt(over_all) < parseInt(max)) {
    //     arr.push(item)
    //   }
    // })
    // setTableData([])
    // setTableData(arr)
  }
  const changeFilters = (field: string, value: string, operator: any) => {
    setCurrent(1)
    if (field !== 'all') {
      if (field !== 'completion_status') {
        if (currentFilter === 'status') {
          filters.pop()
        } else if (field === 'question_creator') {
          setFilters([
            {
              field: 'creator_id',
              operator: operator,
              value: value,
            },
            {
              field: 'request_type',
              operator: 'eq',
              value: 'Q',
            },
          ])
        } else if (field === 'variant_creator') {
          setFilters([
            {
              field: 'creator_id',
              operator: operator,
              value: value,
            },
            {
              field: 'request_type',
              operator: 'eq',
              value: 'V',
            },
          ])
        } else {
          setFilters([
            {
              field: field,
              operator: operator,
              value: value,
            },
          ])
        }
      } else {
        setFilters([
          {
            field: 'completion_status',
            operator: 'gte',
            value: parseInt(value.split('-')[0]),
          },
          {
            field: 'completion_status',
            operator: 'lte',
            value: parseInt(value.split('-')[1]),
          },
        ])
      }
    } else if (field === 'all') {
      filters.splice(0, filters.length)

      setFilters(wrFilter)
    }
  }

  const onChange = (page: number, pageSize: number): void => {
    setCurrent(page)
    setPageSize(pageSize)
  }
  const changeSortOrder = (e: any, order: any) => {
    setSorter([
      {
        field: 'created_at',
        order: order,
      },
    ])
  }
  const questionSearch = (value: string) => {
    setFilters([
      {
        field: 'name',
        operator: 'contains',
        value: `%${value}%`,
      },
    ])
    updateUserLastSearch('work_requests', value)
  }
  const clearSearch = () => {
    filters.splice(0, filters.length)
    setFilters([])

    formSearch?.resetFields()
    setSearchText('')
    updateUserLastSearch('work_requests', '')
    setFilters(wrFilter)
    // tableQueryResult?.refetch()
  }
  return (
    <>
      <List
        title={request?.id !== undefined ? 'Associated Work Requests' : null}
        pageHeaderProps={{
          extra: [
            <>
              <MoreFilter
                key="filter"
                percent={tableQueryResult}
                filterByCompletionStatus={filterByCompletionStatus}
                changeFilters={changeFilters}
                source={'Work Requests'}
              />
              {/* , // <ExportButton onClick={triggerExport} loading={isLoading} />, */}
              <RefreshButton key="refresh" onClick={() => tableQueryResult?.refetch()} />
              {request?.id === undefined ? (
                <CreateButton
                  key="create"
                  style={{ display: createPermission !== undefined && createPermission?.granted ? 'block' : 'none' }}
                  type="primary"
                  icon={<PlusOutlined />}
                  onClick={() => {
                    createFormProps?.form?.resetFields()
                    createShow()
                  }}
                />
              ) : null}
            </>,
          ],
        }}
      >
        {readPermission !== undefined && readPermission.granted ? (
          <>
            <Divider />
            <Row gutter={[16, 16]}>
              <Col xs={24} sm={12} md={12} lg={8} xl={6}>
                <div className="ams-stat-card">
                  <h4>
                    Total Work Requests:
                    <span> {workRequestCount?.totalCount}</span>
                  </h4>
                </div>
              </Col>
              <Col xs={24} sm={12} md={12} lg={8} xl={6}>
                <div className="ams-stat-card">
                  <h4>
                    Closed Work Requests:
                    <span> {workRequestCount?.closedWorkRequest}</span>
                  </h4>
                </div>
              </Col>
              <Col xs={24} sm={12} md={12} lg={8} xl={6}>
                <div className="ams-stat-card">
                  <h4>
                    Progress Work Requests:
                    <span>{workRequestCount?.inProgressWorkRequest}</span>
                  </h4>
                </div>
              </Col>
              <Col xs={24} sm={12} md={12} lg={8} xl={6}>
                <div className="ams-stat-card">
                  <h4>
                    Open Work Requests:{' '}
                    <span> {workRequestCount?.openWorkRequest}</span>
                  </h4>
                </div>
              </Col>
              {workRequestCount.draftWorkRequest > 0 ? (
                <Col xs={24} sm={12} md={12} lg={8} xl={6}>
                  <div className="ams-stat-card">
                    <h4>
                      Draft Work Requests:
                      <span> {workRequestCount?.draftWorkRequest}</span>
                    </h4>
                  </div>
                </Col>
              ) : (
                ''
              )}
            </Row>
            <Divider style={{ margin: ' 0', paddingBottom: 5, marginTop: 20 }} />
          </>
        ) : (
          ''
        )}
        {readPermission !== undefined && readPermission.granted ? (
          <>
            <div className="ams-list-toolbar">
              <Radio.Group name="radiogroup" defaultValue={1}>
                <Radio value={1} onChange={(e: any) => changeSortOrder(e, 'desc')}>
                  Last Created
                </Radio>
                <Radio value={2} onChange={(e: any) => changeSortOrder(e, 'asc')}>
                  First Created
                </Radio>
              </Radio.Group>
            </div>
            <Form form={formSearch} className="ams-list-filters">
              <Row gutter={[16, 12]} align="middle" className="ams-search-row">
                <Col xs={24} md={20} lg={21} xl={22}>
                  <Search
                    name="question_search"
                    placeholder="input search text"
                    enterButton="Search"
                    size="large"
                    onSearch={questionSearch}
                    value={searchText}
                    onChange={(e: any) => setSearchText(e?.target?.value)}
                    style={{ width: '100%' }}
                  />
                </Col>
                <Col xs={24} md={4} lg={3} xl={2}>
                  <Button htmlType="button" onClick={clearSearch} style={{ width: '100%' }}>
                    Clear
                  </Button>
                </Col>
              </Row>

              <Row>
                <Col span={24}>
                  <QuestionFilter
                    changeFilters={changeFilters}
                    source={'Work Requests'}
                    hideFilters={['blooms', 'topic', 'report_theme', 'theme', 'sub_theme', 'difficulty_level']}
                  />
                </Col>
              </Row>
            </Form>

            <Divider style={{ margin: 0, paddingBottom: 5, marginTop: 16 }} />
            <div className="ams-list-table">
            <Table
              size="small"
              columns={columns}
              loading={tableQueryResult?.isLoading}
              dataSource={tableQueryResult?.data?.data}
              pagination={{
                total: tableQueryResult?.data?.total,
                onChange,
                current: current,
              }}
              scroll={{ x: 'max-content' }}
            />
            </div>
          </>
        ) : null}

        {/* <Pagination total={pageCount} current={current} setCurrent={setCurrent} /> */}
        {createPermission !== undefined && createPermission.granted ? (
          <CreateWorkRequest
            success={success}
            refreshData={refreshData}
            modalProps={createModalProps}
            formProps={createFormProps}
            close={createClose}
          />
        ) : null}
        {editPermission !== undefined && editPermission.granted ? (
          <EditWorkRequest
            close={editClose}
            refreshData={refreshData}
            modalProps={editModalProps}
            formProps={editFormProps}
            record={record}
            updatePercentage={{}}
          />
        ) : null}
        {createPermission !== undefined && createPermission.granted ? (
          <CloneWorkRequest close={cloneClose} refreshData={refreshData} modalProps={cloneModalProps} formProps={cloneFormProps} record={record} />
        ) : null}
      </List>
    </>
  )
}
